/** Minimal observable value. The UI is small enough that this beats pulling in a framework. */
export type Unsubscribe = () => void;

export class Store<T> {
  private listeners = new Set<(value: T, previous: T) => void>();

  constructor(private value: T) {}

  get(): T {
    return this.value;
  }

  set(next: T): void {
    if (Object.is(next, this.value)) return;
    const previous = this.value;
    this.value = next;
    for (const listener of this.listeners) listener(next, previous);
  }

  update(fn: (current: T) => T): void {
    this.set(fn(this.value));
  }

  subscribe(listener: (value: T, previous: T) => void, immediate = false): Unsubscribe {
    this.listeners.add(listener);
    if (immediate) listener(this.value, this.value);
    return () => this.listeners.delete(listener);
  }
}
